export default "/images/slack.svg?ba47bf3bced42a9a65ac9a1e03bd5fe9";